import React, { useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import { outlinedInputSx } from "lib/muiStyle/muiStyle";
import Label from "components/Input/Label/Label";
import HelperMessage from "components/Input/HelperMessage/HelperMessage";
import c from "lib/style/colorVar.scss";

const OutlinedText = ({
  label,
  mandatory,
  placeholder,
  errorMessage,
  noErrorMessage,
  onEnterDownFn,
  onchangeFn,
  onfocusFn,
  onblurFn,
  value,
  defaultValue,
  sxParams = {},
  disabled,
  multiline,
  readonly,
  endAdornment,
  divStyle,
  id,
  percentageSymbol,
}) => {
  const [focus, setFocus] = useState(false);
  const { textFocus, textError } = sxParams;
  const onKeyDownHandler = (e) => {
    if (e.key === "Enter") {
      onEnterDownFn && onEnterDownFn();
    }
  };

  return (
    <div style={divStyle}>
      <Label label={label} mandatory={mandatory} />
      <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
        <OutlinedInput
          style={disabled ? { background: c.disabledFieldBg } : {}}
          size={"small"}
          id={id ?? label}
          value={value}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onKeyDown={onKeyDownHandler}
          onChange={onchangeFn}
          onFocus={onfocusFn ?? (() => setFocus(true))}
          onBlur={onblurFn ?? (() => setFocus(false))}
          sx={() => outlinedInputSx(textFocus ?? focus, textError)}
          disabled={disabled}
          multiline={multiline}
          rows={multiline ? 5 : 1}
          endAdornment={
            percentageSymbol ? (
              <InputAdornment position="end">
                <span style={{ color: c.textSecondary }}>%</span>
              </InputAdornment>
            ) : (
              endAdornment
            )
          }
          slotProps={{
            input: {
              readOnly: readonly,
            },
          }}
        />
        {!percentageSymbol && endAdornment}
      </div>
      {!noErrorMessage && <HelperMessage message={textError && errorMessage} />}
    </div>
  );
};

export default React.memo(OutlinedText);
